import React from 'react'

const ProductCardSkeleton = (): JSX.Element => {
  return (
    <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
      {/* Header */}
      <div className="flex h-14 items-center justify-between bg-gray-200 px-6 animate-pulse">
        <div className="h-5 w-32 rounded bg-gray-300" />
        <div className="h-5 w-16 rounded bg-gray-300" />
      </div>

      {/* Body */}
      <div className="relative p-4">
        {/* Discount Badge */}
        <div className="absolute left-0 top-0 h-10 w-10 rounded-br-lg bg-gray-200 animate-pulse" />

        <div className="flex gap-4">
          {/* Product Image */}
          <div className="h-20 w-20 flex-shrink-0 rounded-xl bg-gray-200 animate-pulse" />

          {/* Content */}
          <div className="flex flex-1 flex-col justify-between">
            <div>
              <div className="mb-3 h-5 w-40 rounded bg-gray-200 animate-pulse" />

              <div className="flex gap-2">
                <div className="h-4 w-8 rounded bg-gray-200 animate-pulse" />
                <div className="h-4 w-10 rounded bg-gray-200 animate-pulse" />
              </div>
            </div>

            <div className="mt-5 flex items-center justify-between gap-3">
              <div className="h-10 w-32 rounded-lg bg-gray-200 animate-pulse" />
              <div className="h-10 w-24 rounded-lg bg-gray-200 animate-pulse" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductCardSkeleton
